import React from "react";
import { Container } from "reactstrap";

function Login(props) {
  return (
    <Container
      // className={`flex justify-center items-center h-screen w-screen bg-[#fcecc9]`}
      className={`flex justify-center items-center min-h-screen w-screen bg-[#8000000f] overflow-x-hidden`}
    >
      {props.children}
    </Container>
  );
}

export default Login;
